import { render, staticRenderFns } from "./ServiceDescriptionForm.vue?vue&type=template&id=2fafeca6&"
import script from "./ServiceDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./ServiceDescriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDescriptionForm.vue?vue&type=style&index=0&id=2fafeca6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports